<template>
  <v-app>
    <v-app-bar
      app
      :color="currentThemeColor"
      dark
      elevation="4"
      :height="compact ? 56 : 70"
      class="main-app-bar"
      :style="{ backgroundColor: currentThemeColor + ' !important' }"
    >
      <div class="bar">
        <!-- Identité -->
        <div class="bar-brand">
          <v-img
            alt="Hublot"
            class="brand-logo"
            contain
            :src="logoSrc"
            :width="compact ? 36 : 90"
            :height="compact ? 36 : 90"
            :max-width="compact ? 36 : 90"
            :max-height="compact ? 36 : 90"
          />
          <div v-if="showBrandText" class="brand-text ml-3">
            <div class="text-h6 font-weight-medium">Carte des</div>
            <div class="text-subtitle-1 font-weight-light">magasins</div>
          </div>
        </div>

        <!-- Contexte + recherche -->
        <div class="bar-controls">
          <ContextSwitch />
          <Toolbar />
        </div>

        <!-- Actions -->
        <div class="bar-actions">
          <v-menu
            offset-y
            left
            :content-class="compactFilter ? 'enseigne-menu-dropdown mobile-enseigne-menu' : 'enseigne-menu-dropdown'"
            :max-width="compactFilter ? 280 : 400"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="compactFilter"
                icon
                v-bind="attrs"
                v-on="on"
                class="action-btn"
                aria-label="Filtrer par enseigne"
              >
                <v-icon>mdi-filter-variant</v-icon>
              </v-btn>
              <v-btn
                v-else
                color="white"
                class="filter-btn"
                v-bind="attrs"
                v-on="on"
                height="50"
              >
                <v-icon left :color="currentThemeColor">mdi-filter-variant</v-icon>
                <span :style="{ color: currentThemeColor }">Filtrer par enseigne</span>
                <v-icon right :color="currentThemeColor">mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-card :class="compact ? 'pa-2' : 'pa-3'">
              <EnseigneRadio :mobile="compact" />
            </v-card>
          </v-menu>

          <v-btn icon @click="gpsZoom" class="action-btn" aria-label="Vue France entière">
            <v-icon>mdi-crosshairs-gps</v-icon>
          </v-btn>

          <v-btn
            v-if="showBrandText"
            href="https://hublot.io"
            target="_blank"
            text
            class="external-link-btn"
          >
            HUBLOT.IO
            <v-icon right small>mdi-open-in-new</v-icon>
          </v-btn>
        </div>
      </div>
    </v-app-bar>
    
<!-- <NavigationDrawer /> -->
    <v-main>
      <Map/>
      <StoreCounter/>
    </v-main>
  </v-app>
</template>

<script>
import MapComponent from './components/Map';
// import NavigationDrawer from './components/NavigationDrawer';
import Toolbar from './components/Toolbar';
import EnseigneRadio from './components/EnseigneRadio';
import ContextSwitch from './components/ContextSwitch';
import StoreCounter from './components/StoreCounter';

export default {
  name: 'App',

  components: {
    Map: MapComponent,
    Toolbar,
    EnseigneRadio,
    ContextSwitch,
    StoreCounter,
    // NavigationDrawer
  },

  data: () => ({
    selectedEnseigneFilter: null
  }),

  computed: {
    enseignes() {
      return this.$store.state.enseignes.all
    },
    enseignesList() {
      const uniqueEnseignes = [...new Set(this.enseignes.map(e => e.enseigne))]
      return uniqueEnseignes.sort()
    },
    context() {
      return this.$store.state.enseignes.context
    },
    // Barre compacte : le contexte passe en icônes et la recherche en spotlight
    compact() {
      return this.$vuetify.breakpoint.smAndDown
    },
    // Le libellé du filtre ne tient plus avant lg
    compactFilter() {
      return this.$vuetify.breakpoint.mdAndDown
    },
    showBrandText() {
      return this.$vuetify.breakpoint.lgAndUp
    },
    logoSrc() {
      if (this.compact) {
        return this.context === 'boucherie'
          ? '/images/hublot-rond-boucherie.png'
          : '/images/hublot-rond-poisson.png'
      }
      return this.context === 'boucherie'
        ? '/images/hublot-blanc-boucherie.png'
        : '/images/hublot-blanc-poisson.png'
    },
    currentThemeColor() {
      return this.context === 'boucherie' ? '#9d0419' : '#376374'
    }
  },

  methods: {
    gpsZoom() {
      this.$store.dispatch('resetZoom')
    },
    selectEnseigne(enseigne) {
      this.selectedEnseigneFilter = enseigne
      // Dispatcher au store pour filtrer les marqueurs
      this.$store.dispatch('setEnseigneFilter', enseigne)
    },
    getEnseigneImage(enseigne) {
      if (enseigne.includes('Intermarché')) return 'intermarche'
      if (enseigne.includes('E.Leclerc')) return 'leclerc'
      if (enseigne.includes('Super U')) return 'superu'
      if (enseigne.includes('Indépendant')) return 'independant'
      if (enseigne.includes('Carrefour')) return 'carrefour'
      return 'independant'
    }
  }
};
</script>

<style scoped>
.main-app-bar {
  z-index: 1500 !important;
  transition: background-color 0.3s ease !important;
}

.main-app-bar >>> .v-toolbar__content {
  padding: 0 16px !important;
}

/* Trois régions de largeur déterminée : les extrémités gardent leur taille,
   seul le centre se comprime. La barre ne peut plus déborder. */
.bar {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
}

.bar-brand {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}

.bar-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 0;
}

.bar-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
}

.brand-logo {
  flex: 0 0 auto;
  transition: transform 0.2s ease;
}

.brand-logo:hover {
  transform: scale(1.05);
}

.brand-text {
  line-height: 1.2;
  white-space: nowrap;
}

.brand-text > div {
  line-height: 1.2;
}

.action-btn {
  color: white !important;
  flex: 0 0 auto;
}

.filter-btn {
  flex: 0 0 auto;
  min-width: 0 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  font-weight: 500 !important;
  border-radius: 25px !important;
  padding: 0 20px !important;
  white-space: nowrap;
  background-color: white !important;
  border: 2px solid #e0e0e0 !important;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08) !important;
  transition: all 0.3s ease;
}

.filter-btn:hover {
  border-color: currentColor !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-1px);
}

.enseigne-menu-dropdown {
  z-index: 2500 !important;
}

.mobile-enseigne-menu {
  z-index: 2500 !important;
  margin-top: 8px;
}

.external-link-btn {
  flex: 0 0 auto;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  transition: all 0.2s ease;
}

.external-link-btn:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

@media (max-width: 959px) {
  .main-app-bar >>> .v-toolbar__content {
    padding: 0 8px !important;
  }

  .bar {
    gap: 4px;
  }

  .bar-controls {
    gap: 6px;
  }

  .action-btn {
    width: 36px !important;
    height: 36px !important;
  }
}

@media (max-width: 359px) {
  .main-app-bar >>> .v-toolbar__content {
    padding: 0 4px !important;
  }

  .bar,
  .bar-controls,
  .bar-actions {
    gap: 2px;
  }
}
</style>

